import routes from "@/app.route";
import Image from "next/image";
import Link from "next/link";
import SparkleEffect from "./sparkle-effect";

export default function Logo({ className }: { className?: string }) {
  return (
    <SparkleEffect>
      <Link href={routes.home.url}>
        <Image
          src="/branding/logo.webp"
          alt="Everse"
          width={1787}
          height={201}
          className={className}
          priority
          fetchPriority="high"
        />
      </Link>
    </SparkleEffect>
  );
}
